import DataTable, { createTheme } from "react-data-table-component";
import { useState,useEffect,useMemo, Fragment } from "react";

import MoreVert from '@mui/icons-material/MoreVert';
import { ManageSearchRounded,Clear,Print } from "@mui/icons-material";
import { Badge, CircularProgress, IconButton, Skeleton } from "@mui/material";
import { EneaButton,tablestyle,modalstyle,parseToLink,dateSort,concurrecySort } from "./Style";
import { TextField } from "@mui/material";
import { blue,blueGrey,green } from "@mui/material/colors";
import { Backdrop,Fade, Modal,Box,Typography} from "@mui/material";
import { Button } from "@mui/material";
import { EsitiCard } from "./EsitiCard";
import { Divider, Grid2 } from '@mui/material';
import ENEAlogo from './ENEAlogo';
import { GaraCard } from "./GaraCard";
import { ENEA_GEST_API_URL } from './Statics';


const baseurl= ENEA_GEST_API_URL;
//const baseurl = "https://dati.enea.it/gest/catalog/"
const gareurl = baseurl+"gare/search?page=1&per_page=99999&q=";
const esitiurl = baseurl+"esiti/";

// https://react-data-table-component.netlify.app/?path=/story/custom-styles-compact-grid--compact-grid&globals=backgrounds.grid:!false


createTheme(
	'ENEA',
	{
		text: {
			primary: blue[900],
			secondary: blue[900],
		},
		background: {
			default: '#ffffff',
		},
		context: {
			background: blue[900],
			text: '#aaaaaa',
		},
		divider: {
			default: blue[200],
		},
		button: {
      default: blue[800],
			hover: 'rgba(0,0,0,.08)',
			focus: 'rgba(255,255,255,.12)',
			disabled: 'rgba(255, 255, 255, .34)',
		},
		sortFocus: {
			default: blue[800],
		},
	},
);


//<Clear sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
const TableGare =({showid,mindate,maxdate})=>{

    const [json,setJson]=useState([]);
    const [busy,setBusy]=useState(false);
    const [page,setPage]=useState(0);
    const [details,setDetails]=useState();
    const [openDetails,setShowDetails]=useState(false);
    const [filterText,setFilterText]=useState('');
    const [find,setFind]=useState([]);
    const [showEsito,setShowEsito]=useState();
    const [esito,setEsito]=useState();
    const [fetching,setFetching]=useState("");
    //const [directshow,setDirectShow]=useState(showid);

    
    useEffect(()=>{
      console.log("search on gare "+filterText);
    },[filterText])
    
    useEffect(()=>{
      if(openDetails===false){
        setShowEsito();
      }
    },[openDetails])

    const subHeaderComponentMemo = () => {

      const handleClear = () => {
          setFilterText("");
        };
      const handleChange = (val) => {
          setFilterText(val);
        };

      return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ManageSearchRounded sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
              <TextField fullWidth 
                size="small" 
                variant='outlined' 
                value={filterText} 
                label="Ricerca full-text" 
                onChange={(e)=>handleChange(e.target.value)}/>
              <IconButton aria-label="clear" aria-roledescription="clear button" sx={{color:blue[800]}} onClick={()=>handleClear()}>
              <Clear/>
            </IconButton>
          </Box>
          );
    };

    useEffect(()=>{
      if(showEsito!==undefined){
        console.log("load esito "+showEsito);
        let turl = new URL(esitiurl+showEsito);
        fetch(turl,{
          method:'GET'
        }).then(resp=>resp.json())
          .then(j=>{
          if(j.length>0){
            console.log("esito "+showEsito+" loaded"); 
            setEsito(j[0]);   
          }else{
            console.log("no elements "+j);
          }
        }
      ).catch(err=>{console.log("err")})
      }else{
        setEsito();
      }
    },[showEsito]);


    const getDetail = (url)=>{
      setBusy(true);
      fetch(url,{
          method:'GET'
      }).then(resp=>resp.json())
        .then(j=>{
          setBusy(false);
          if(j.length>0){
            setDetails(j[0]);
            setShowDetails(true);    
          }else{
            console.log("too much elements "+j);
          }
        }
      ).catch(err=>{console.log("err")})
    }

    const columns = [{
      name:<Typography variant="body2">Scadenza gara</Typography>,
      selector: row => new Date(row.scadenza_offerta).toLocaleDateString()||'-',
      sortable: true,
      sortFunction: (a,b)=>{
        return new Date(a.scadenza_offerta)-new Date(b.scadenza_offerta);
      },
      width:"130px",
  },
  {
      name: <Typography variant="body2">Identificativo</Typography>,
      selector: row => row.id,
      sortable: true,
      width:"115px",
    },
  {
      name: <Typography variant="body2">Oggetto</Typography>,
      selector: row => row.oggetto_appalto,
      sortable: true,
      grow:true,
      wrap:true,
      minWidth:"300px",
  },
  {
    name: <Typography variant="body2">Procedura</Typography>,
    selector: row => row.procedura_nome,
    grow:true,
    wrap:true,
    sortable: true,
    minWidth:"200px",
},
  {
    name: <Typography variant="body2">Dettagli</Typography>,
    selector: row => {
          return (
            <Fragment>
            <IconButton aria-label="detail" aria-roledescription="get details" sx={{textWrap:'auto',color:blue[800]}} onClick={()=>getDetail(parseToLink(row.dettaglio))}>
              <MoreVert/><Typography variant="body2" component="span">apri dettagli</Typography>
            </IconButton>
            </Fragment>
          );
      },
    sortable: false,
    grow:true,
    
    minWidth:"150px",
  },]
    /* filter effect */
    useEffect(()=>{
      //let rex = filterText.trim().replace(" ",".+");
      if(filterText.length>0){
        let regex = new RegExp(filterText.trim().replaceAll(" ",".+"), "i");
        const find = json.filter( singlerow => {
          return Object.values(singlerow).filter( v => {
            if(typeof v === 'string' || v instanceof String)  
              return v.match(regex)!==null;
            return false;
          }).length>0
        }).map( o =>o);
        setFind(find);
      }else{
        setFind(json);
      }
    },[json,filterText]);


      const myfetch = (url,page,arraydest,cb)=>{
        let turl = new URL(url);
        
        if((page!==undefined)&&(page!==0)){
          turl.searchParams.set("page",page);
        } else{
          turl.searchParams.set("page",1);
        }
        setBusy(true);
        fetch(turl,{
          method:'GET'
        }).then(resp=>resp.json())
        .then(j=>{
          arraydest.push(j.data);
          if(j.current_page<j.last_page){
            myfetch(url,j.current_page+1,arraydest,cb);
            setPage(j.current_page+1);
            setFetching("Righe per pagina");
          } else {
             /* filter by min/max date if present */
            let filterdata = [];
            let tmpdata = [];
            
            if(mindate!==undefined){
              tmpdata = (arraydest.flatMap(o=>o).filter(f=>new Date(f.scadenza_offerta)>=new Date(mindate)));
            } else {
              tmpdata = (arraydest.flatMap(o=>o));
            }
            if(maxdate!==undefined){
              filterdata = (tmpdata.filter(fm=>new Date(fm.scadenza_offerta)<=new Date(maxdate)));
            }else{
              filterdata = (tmpdata);
            }

            setJson(filterdata);

            //setJson(arraydest.flatMap(o=>o));
            setBusy(false);
            setFetching("in caricamento...");
            cb(j);
          }
        }).catch(err=>{console.log("err")})
      };
      
      useEffect(()=>{
        if(showid!==''){
          getDetail(parseToLink('/api/v1/gare/'+showid));
        } else {
          myfetch(gareurl,0,[],()=>{
            console.log("Gare finish");
          });
        }
      },[]);

      
      return (
        <Fragment role="main">
          {showid==='' && (<DataTable 
                    className="to-screen"
                    customStyles={tablestyle} 
                    highlightOnHover 
                    subHeader 
                    subHeaderComponent={subHeaderComponentMemo()} 
                    persistTableHead 
                    theme="ENEA" 
                    progressPending={busy}  
                    progressComponent={
                      <p><CircularProgress/></p>
                    }
                    ariaLabel="gare" 
                    columns={columns} 
                    data={find} 
                    paginationComponentOptions={{
                      rowsPerPageText:"Righe per pagina",
                    }}
                    pagination />)}
         {details!==undefined && (
          <Modal
            aria-labelledby="modal-detail-title"
            aria-describedby="modal-detail-description"
            open={openDetails}
            onClose={()=>setShowDetails(false)}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
              timeout: 500,
            },
            
          }}>
            <Fade in={openDetails}>
            <Box sx={{ ...modalstyle, width: '88%', overflowY:'visible' }}>
              <Grid2 container sx={{justifyContent: "space-between",alignItems: "center",}} columns={2}>
                <Grid2 size={1}>
                
                <Typography variant="h1" sx={{fontSize:36}} id="modal-detail-title">
                  <ENEAlogo/>
                    Scheda di dettaglio {showEsito===undefined?"gara "+details.id:"esito "+showEsito}
                  </Typography>
                </Grid2>
                <Grid2 size={1} sx={{width:"fit-content"}} >
                  <IconButton title="stampa scheda" ariaLabel="stampa scheda" color="primary" onClick={()=>{
                      window.print();
                    }
                    }>
                    <Print sx={{width:50,height:50}} />
                  </IconButton>    
                  {(showid===''||esito!==undefined) && (<IconButton title="chiudi scheda" ariaLabel="chiudi scheda" color="primary" onClick={()=>{
                      if(esito!==undefined) 
                        setShowEsito();
                      else 
                        setShowDetails(false);
                      }
                    }>
                      <Badge badgeContent={showEsito===undefined?null:1} color="primary">
                        <Clear sx={{width:50,height:50}} />
                      </Badge>
                  </IconButton>)}
                </Grid2>
                <Grid2 size={2}>
                  <Typography variant="h2" sx={{fontSize:24}} component="div" id="modal-detail-description" >
                    {details.oggetto_appalto}
                  
                  </Typography>
                </Grid2>
              </Grid2>
              {showEsito===undefined && (<GaraCard detail={details} handleclose={()=>setShowDetails(false)} showclose={showid===''} showesiti={(e)=>setShowEsito(e)} />)}
              {esito!==undefined && (<EsitiCard detail={esito} handleclose={()=>setShowEsito()}  showclose={true} />)}
              </Box>  
              
            </Fade>
          </Modal>
        )}
        </Fragment>
        )
}

export default TableGare;